


import React from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Login from "../pages/auth/Login";
import Forgotpw from "./../pages/auth/Forgotpw";
import ForgotResetPassword from "./../pages/auth/ForgotResetpw";
import ResetPassword from "./../pages/auth/ResetPassword";
import NotAuthorized from "./../pages/errors/Unauthorized";
import DashboardLayout from "../components/layout/DashboardLayout";
import { routeComponentMap } from "./routeComponentMap";
import NotFound from "../pages/errors/404";
import RedirectIfAuth from "../components/features/Auth/RedirectIfAuth";
import DashboardOne from "../pages/dashboard/DashboardOne";
import SupportRoutes from "./SupportRoutes";
import SupportRequestList from "../admin/SupportRequestList";
import { enqueueSnackbar } from "notistack"; // ⬅ add this at the top

const AppRoutes = () => {

  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");

    if (!token) {
      enqueueSnackbar("Session Expired. Please Login.", {
        variant: "error",
      })
      return <Navigate to="/" replace />;

    }
    return children;
  };


  return (
    <Routes>
      <Route
        path="/"
        element={
          <RedirectIfAuth>
            <Outlet />
          </RedirectIfAuth>
        }
      >
        <Route index element={<Login />} />
        <Route path="forgotpw" element={<Forgotpw />} />
      </Route>

      <Route path="setpw" element={<ResetPassword />} />
      <Route path="resetpw" element={<ForgotResetPassword />} />
      <Route path="/support/*" element={<SupportRoutes />} />
      <Route path="unauthorized" element={<NotAuthorized />} />
      <Route path="*" element={<NotFound />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardOne />} />
        <Route path="support-requests" element={<SupportRequestList />} />
        {Object.entries(routeComponentMap).map(([path, Component], index) => (
          <Route key={index} path={path} element={<Component />} />
        ))}
      </Route>
    </Routes>

  );
};

export default AppRoutes;
